module.exports = __webpack_public_path__ + "static/media/rename.37ade1b6.svg";